import { Helmet } from "react-helmet-async";
import { useLanguage } from "../contexts/LanguageContext";

const SITE_NAME = "Buy Likes and Followers";

export default function SEOHead({ title, description, schema, noindex = false, ogType = "website", image }) {
  const { language } = useLanguage();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const canonicalUrl = origin ? `${origin}${path}` : undefined;
  const schemas = Array.isArray(schema) ? schema.filter(Boolean) : schema ? [schema] : [];
  const ogImage = image || (origin ? `${origin}/og-image.png` : "/og-image.png");

  return (
    <Helmet>
      <html lang={language === "en" ? "en" : "fr"} />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={ogType} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={language === "en" ? "en_US" : "fr_FR"} />
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
